/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export interface ModelData {
  model: string
  version: string
  variation: string
}



/**
 * Checks if the given modelName is a shape model.
 * 
 * @param modelName - The name of the model to check.
 * @returns A boolean indicating whether the modelName is a shape model.
 */
export const isShapeModel = (modelName: string): boolean => {
  return (
    modelName === "Circle" || modelName === "Rectangle" || modelName === "Curvilinear_Triangle"
  )
}
